module.exports = __webpack_public_path__ + "img/truecaller.847eeb31.svg";